<template>
    <div>
        <div style="margin-bottom: 5px">
            <el-input
                v-model="name"
                placeholder="请输入商品名称"
                suffix-icon="el-icon-a-042"
                style="width: 200px"
                @keyup.enter.native="loadPost"
            ></el-input>
            <el-button
                type="primary"
                style="margin-left: 5px; font-size: 18px"
                @click="loadPost"
            >
                查询</el-button
            >
            <el-button
                type="warning"
                @click="resetParam"
                style="font-size: 18px"
            >
                重置</el-button
            >

           <el-button
                type="info"
                style="margin-left: 5px; font-size: 18px"
                @click="addGoods()"
            >
                手动新增商品</el-button
            >
			<el-button
			     type="danger"
			     style="margin-left: 5px; font-size: 18px"
			     @click="addGoodsByVoice()"
			 >
			     语音新增商品</el-button
			 >
			<!-- <el-button
			      type="primary"
			      style="margin-left: 5px; font-size: 18px"
			      @click="printAll"
			  >
			      打印订货单</el-button> 
			  <el-button
				   type="success"
				   style="margin-left: 5px; font-size: 18px"
				   @click="printQrCode"
			   >
				   打印二维码</el-button>-->
				  
        </div>
        <el-table
		    height="400"
            :data="tableData"
            :header-cell-style="{ background: '#f2f5fc', color: '#555555' }"
            border
        >
            <!-- <el-table-column prop="id" label="ID" width="60"> </el-table-column> -->
            <el-table-column prop="qrcodeUrl" label="商品图片" >
				<template slot-scope="scope">
					<el-image style="width: 6.25rem; height: 6.25rem;" :src="baseUrl+scope.row.goodsImgUrl"></el-image>
				</template>
			</el-table-column>
			<el-table-column prop="goodsName" label="商品名称"width="100"></el-table-column>
			<el-table-column prop="fee" label="单价" width="60"></el-table-column>
			<el-table-column prop="goodsNum" label="订货数量" width="80"></el-table-column>
            <el-table-column prop="realGoodsNum" label="实际数量" width="80">
                <template slot-scope="scope">
                    <el-input v-model="scope.row.realGoodsNum" @change="modNum(scope.row)" placeholder="请输入实际数量"></el-input>
                </template>
            </el-table-column>
			<el-table-column prop="unit" label="商品单位" width="80"></el-table-column>
			<el-table-column prop="totalMoney" label="总价" width="80"></el-table-column>
			<el-table-column prop="orderStatus" label="订货状态" width="80" :formatter="orderInfoState"></el-table-column>
			<el-table-column prop="orderTime" :formatter="formatDateTime" label="下单时间" width="180"></el-table-column>
			<!-- <el-table-column prop="qrcodeUrl" label="二维码" >
				<template slot-scope="scope">
					<el-image :src="baseUrlQrcode+scope.row.qrcodeUrl"></el-image>
				</template>
			</el-table-column> -->
            <el-table-column prop="remarks" label="备注" width="80"> </el-table-column>
            <el-table-column
                prop="operate"
                label="操作"
                width="240"
                fixed="right"
            >
                <template slot-scope="scope">
                    
					<el-button
					    style="font-size: 18px"
					    type="success"
					    @click="mod(scope.row)"
						v-if="scope.row.orderStatus==1"
					>
					    编辑</el-button
					>
					<el-popconfirm
					    title="确定删除吗？"
					    @confirm="del(scope.row.id)"
					    style="margin-left: 5px"
					>
					    <el-button
					        slot="reference"
					        type="danger"
					        style="font-size: 18px"
					    >
					        删除</el-button
					    >
					</el-popconfirm>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            :page-sizes="[5, 10, 20, 30]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
        >
        </el-pagination>

		<el-dialog
		    title="手动添加商品"
		    :visible.sync="orderInfoGoodsDialogVisible"
		    width="30%"
		    append-to-body
		>
		    <el-form ref="orderInfo" :rules="orderInfoRules" :model="orderInfo" label-width="80px">
		        <el-dialog
		            width="75%"
		            title="选择商品"
		            :visible.sync="innerVisible"
		            append-to-body
		        >
		            <SelectGoods @doSelectGoods="doSelectGoods"></SelectGoods>
		            <span slot="footer" class="dialog-footer">
		                <el-button
		                    @click="innerVisible = false"
		                    style="font-size: 18px"
		                    >
		                     取 消</el-button
		                >
		                <el-button
		                    type="primary"
		                    @click="confirmGoods"
		                    style="font-size: 18px"
		                    >
		                     确 定</el-button
		                >
		            </span>
		        </el-dialog>
				<el-form-item label="商品名称">
				    <el-col :span="20">
				        <el-input
				            v-model="orderInfo.goodsName"
				            readonly
				            @click.native="selectGoods"
				        ></el-input>
				    </el-col>
				</el-form-item>
				<el-form-item label="商品单位">
				    <el-col :span="20">
				        <el-input
				            v-model="orderInfo.unit"
				            readonly
				        ></el-input>
				    </el-col>
				</el-form-item>
				<el-form-item label="订购数量">
				    <el-col :span="20">
				        <el-input
				            v-model="orderInfo.goodsNum"
				        ></el-input>
				    </el-col>
				</el-form-item>
                
				<el-form-item label="商品单价">
				    <el-col :span="20">
				        <el-input
				            v-model="orderInfo.fee"
				        ></el-input>
				    </el-col>
				</el-form-item>
		        <el-form-item label="备注" prop="remarks">
		            <el-col :span="20">
		                <el-input
		                    type="textarea"
		                    v-model="orderInfo.remarks"
		                ></el-input>
		            </el-col>
		        </el-form-item>
		    </el-form>
		    <span slot="footer" class="dialog-footer">
		        <el-button
		            @click="orderInfoGoodsDialogVisible = false"
		            style="font-size: 18px"
		            >
		            取 消</el-button
		        >
		        <el-button type="primary" @click="saveOrderInfo" style="font-size: 18px"
		            >
		            确 定</el-button
		        >
		    </span>
		</el-dialog>
		
		<el-dialog
		    title="语音添加商品"
		    :visible.sync="voiceGoodsDialogVisible"
		    width="30%"
		    append-to-body
		>
		    <el-form ref="orderInfo" :rules="orderInfoRules" :model="orderInfo" label-width="80px">
		        <el-form-item label="" prop="goodsStr">
		            <el-col :span="20">
		                <el-input
		                    type="textarea"
		                    v-model="orderInfo.goodsStr"
		                ></el-input>
		            </el-col>
		        </el-form-item>
		    </el-form>
		    <span slot="footer" class="dialog-footer">
		        <el-button
		            @click="voiceGoodsDialogVisible = false"
		            style="font-size: 18px"
		            >
		            取 消</el-button
		        >
		        <el-button type="primary" @click="saveOrderInfoBatch" style="font-size: 18px"
		            >
		            确 定</el-button
		        >
		    </span>
		</el-dialog>
		
		<el-dialog
		    title="编辑商品"
		    :visible.sync="editOrderInfoDialogVisible"
		    width="30%"
		    append-to-body
		>
		    <el-form ref="orderInfo" :rules="orderInfoRules" :model="orderInfo" label-width="80px">
				<el-form-item label="商品名称">
				    <el-col :span="20">
				        <el-input
				            v-model="orderInfo.goodsName"
				        ></el-input>
				    </el-col>
				</el-form-item>
				<el-form-item label="商品单位">
				    <el-col :span="20">
				        <el-input
				            v-model="orderInfo.unit"
				        ></el-input>
				    </el-col>
				</el-form-item>
				<el-form-item label="订购数量">
				    <el-col :span="20">
				        <el-input
				            v-model="orderInfo.goodsNum"
				        ></el-input>
				    </el-col>
				</el-form-item>
				<el-form-item label="商品单价">
				    <el-col :span="20">
				        <el-input
				            v-model="orderInfo.fee"
				        ></el-input>
				    </el-col>
				</el-form-item>
		        <el-form-item label="备注" prop="remarks">
		            <el-col :span="20">
		                <el-input
		                    type="textarea"
		                    v-model="orderInfo.remarks"
		                ></el-input>
		            </el-col>
		        </el-form-item>
		    </el-form>
		    <span slot="footer" class="dialog-footer">
		        <el-button
		            @click="editOrderInfoDialogVisible = false"
		            style="font-size: 18px"
		            >
		            取 消</el-button
		        >
		        <el-button type="primary" @click="updateNum" style="font-size: 18px"
		            >
		            确 定</el-button
		        >
		    </span>
		</el-dialog>
    </div>
	
</template>

<script>
	import SelectGoods from "../goods/SelectGoods";
export default {
    name: "UserOrderInfo",
	components: {SelectGoods },
    data() {
        return {
			baseUrl:this.$httpUrl+"/images/",
			baseUrlQrcode:this.$httpUrl+"/qrcode/",
			tempGoods:{},
            tableData: [],
			printTable:[],
            pageSize: 10,
            pageNum: 1,
            total: 0,
            name: "",
			innerVisible: false,
            centerDialogVisible: false,
			orderInfoGoodsDialogVisible:false,
			voiceGoodsDialogVisible:false,
			editOrderInfoDialogVisible:false,
            form: {
                id: "",
                userId: "",
                userName: "",
				orderStatus:"1",
				remarks:""
            },
			orderInfo:{
				id:"",
				userOrderId:"",
				userOrderNo:"",
				goodsId:"",
				goodsName:"",
				goodsNum:"",
                realGoodsNum:"",
				remarks:"",
				fee:"",
				unit:"",
				goodsStr:""
			},
            rules: {
                userName: [
                    {
                        required: true,
                        message: "请选择下单人",
                        trigger: "blur",
                    },
                ],
            },
			orderInfoRules: {
			    goodsName: [
			        {
			            required: true,
			            message: "请选择商品",
			            trigger: "blur",
			        },
			    ],
				goodsNum: [
				    {
				        required: true,
				        message: "请输入商品数量",
				        trigger: "blur",
				    },
				],
			},
			orderInfoStatus:[
				{
					id:1,
					name:"已下单"
				},
				{
					id:2,
					name:"已配货"
				},
				{
					id:3,
					name:"已打码"
				},
				{
					id:4,
					name:"已送达"
				}
			]
        };
    },
	props:{
		userOrderId:{
			type:Number,
			default:""
		},
		userOrderNo:{
			type:String,
			default:""
		},
	},
	watch:{
		userOrderId:{
			handler(newVal,oldVal){
				console.log("userOrderIdnewVal:"+newVal)
				if(newVal){
					this.orderInfo.userOrderId=newVal;
					this.loadPost()
				}
			},
			deep:true,
			immediate:true
		},
		userOrderNo:{
			handler(newVal,oldVal){
				console.log("userOrderNonewVal:"+newVal)
				if(newVal){
					this.orderInfo.userOrderNo=newVal;
				}
			},
			deep:true,
			immediate:true
		}
	},
    methods: {
		formatDateTime(row, column, cellValue, index) {
			console.log(cellValue)
			if(!cellValue){
				return "-"
			}
		  function padZero(num) {
		    return num < 10 ? '0' + num : num;
		  }
		 var date=new Date(cellValue)
		  var year = date.getFullYear();
		  var month = padZero(date.getMonth() + 1);
		  var day = padZero(date.getDate());
		  var hours = padZero(date.getHours());
		  var minutes = padZero(date.getMinutes());
		  var seconds = padZero(date.getSeconds());
		 
		  return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds;
		},
		printAll(){
			printJS({
					printable: this.printTable,
					type: 'json',
					properties: [
						{ field: 'goodsName', displayName: '商品'},
						{ field: 'goodsNum', displayName: '数量'},
						{ field: 'fee', displayName: '单价'},
						{ field: 'totalMoney', displayName: '总价'},
						],
					header: '<h3 class="custom-h3">进货单据</h3>',
					gridHeaderStyle: 'color: red;  border: 1px solid #3971A5;',
					gridStyle: 'border: 1px solid #3971A5;',
					font_size:'6pt'
				  })
		},
		printQrCode(){
			var heads="lalal"
			var url='http://127.0.0.1:9131/01.png'
			printJS({
					printable: url,
					type: 'image',
					header: '<h3 class="custom-h3">'+heads+'</h3>',
					imageStyle: 'width:160px;height:160px;margin-bottom:20px;margin-left:20px'
				  })
		},
		orderInfoState(row){
			let temp = this.orderInfoStatus.find((item) => {
			    return item.id == row.orderStatus;
			});
			
			return temp && temp.name;
		},
		doSelectGoods(val){
			console.log(val);
			this.tempGoods = val;
		},
		confirmGoods() {
		    this.orderInfo.goodsId = this.tempGoods.id;
		    this.orderInfo.goodsName = this.tempGoods.name;
			this.orderInfo.unit = this.tempGoods.unit;
			this.orderInfo.manufacturer = this.tempGoods.manufacturer;
			this.orderInfo.goodsImgUrl = this.tempGoods.imgUrl;
		
		    this.innerVisible = false;
		},
		selectGoods(){
			this.innerVisible = true;
		},
        resetForm() {
            this.$refs.form.resetFields();
        },
        mod(row) {
           
            this.$nextTick(() => {
                //赋值到表单
				this.orderInfo.id=row.id;
				this.orderInfo.goodsId=row.goodsId;
				this.orderInfo.goodsName=row.goodsName;
				this.orderInfo.goodsNum=row.goodsNum;
				this.orderInfo.remarks=row.remarks;
				this.orderInfo.fee=row.fee;
				this.orderInfo.unit=row.unit;
            });
			 this.editOrderInfoDialogVisible = true;
        },
        modNum(row) {
            this.$nextTick(() => {
                //赋值到表单
        		this.orderInfo.id=row.id;
        		this.orderInfo.goodsId=row.goodsId;
        		this.orderInfo.goodsName=row.goodsName;
        		this.orderInfo.goodsNum=row.goodsNum;
                this.orderInfo.realGoodsNum=row.realGoodsNum;
        		this.orderInfo.remarks=row.remarks;
        		this.orderInfo.fee=row.fee;
        		this.orderInfo.unit=row.unit;
            });
            var that=this;
            setTimeout(()=>{that.updateNum()},500)
        	 
        },
		addGoods(){
			this.orderInfo.id="";
			this.orderInfo.goodsId="";
			this.orderInfo.goodsName="";
			this.orderInfo.goodsNum="";
			this.orderInfo.remarks="";
			this.orderInfo.fee="";
			this.orderInfo.unit="";
			this.orderInfoGoodsDialogVisible = true;
		},
		addGoodsByVoice(){
			this.orderInfo.goodsStr="";
			this.voiceGoodsDialogVisible = true;
		},
        add() {
            this.centerDialogVisible = true;
            this.$nextTick(() => {
                this.resetForm();
            });
        },
		saveOrderInfo(){
			this.$refs.orderInfo.validate((valid) => {
			    if (valid) {
			       this.dosaveOrderInfo()
			    } else {
			        console.log("error submit!!");
			        return false;
			    }
			});
			
		},
		saveOrderInfoBatch(){
			this.$axios
			    .post(this.$httpUrl + "/userorderinfo/batchSave", this.orderInfo)
			    .then((res) => res.data)
			    .then((res) => {
			        console.log(res);
			        if (res.code == 200) {
			            this.$message({
			                message: "操作成功！",
			                type: "success",
			            });
			            this.voiceGoodsDialogVisible = false;
			            this.loadPost();
			            // this.resetForm();
			        } else {
			            this.$message({
			                message: "操作失败！",
			                type: "error",
			            });
			        }
			    });
		},
		dosaveOrderInfo(){
			this.$axios
			    .post(this.$httpUrl + "/userorderinfo/save", this.orderInfo)
			    .then((res) => res.data)
			    .then((res) => {
			        console.log(res);
			        if (res.code == 200) {
			            this.$message({
			                message: "操作成功！",
			                type: "success",
			            });
			            this.orderInfoGoodsDialogVisible = false;
			            this.loadPost();
			            // this.resetForm();
			        } else {
			            this.$message({
			                message: "操作失败！",
			                type: "error",
			            });
			        }
			    });
		},
        doSave() {
            this.$axios
                .post(this.$httpUrl + "/userorder/save", this.form)
                .then((res) => res.data)
                .then((res) => {
                    console.log(res);
                    if (res.code == 200) {
                        this.$message({
                            message: "操作成功！",
                            type: "success",
                        });
                        this.centerDialogVisible = false;
                        this.loadPost();
                        this.resetForm();
                    } else {
                        this.$message({
                            message: "操作失败！",
                            type: "error",
                        });
                    }
                });
        },
        updateNum() {
            this.$axios
                .post(this.$httpUrl + "/userorderinfo/update", this.orderInfo)
                .then((res) => res.data)
                .then((res) => {
                    console.log(res);
                    if (res.code == 200) {
                        this.$message({
                            message: "操作成功！",
                            type: "success",
                        });
                        this.editOrderInfoDialogVisible = false;
                        this.loadPost();
                    } else {
                        this.$message({
                            message: "操作失败！",
                            type: "error",
                        });
                    }
                });
        },
        save() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    if (this.form.id) {
                        this.doMod();
                    } else {
                        this.doSave();
                    }
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
            this.pageNum = 1;
            this.pageSize = val;
            this.loadPost();
        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
            this.pageNum = val;
            this.loadPost();
        },
        resetParam() {
            this.name = "";
        },
        loadPost() {
            this.$axios
                .post(this.$httpUrl + "/userorderinfo/listPage", {
                    pageSize: this.pageSize,
                    pageNum: this.pageNum,
                    param: {
                        goodsName: this.name,
						userOrderId:this.userOrderId
                    },
                })
                .then((res) => res.data)
                .then((res) => {
                    console.log(res);
                    if (res.code == 200) {
                        this.tableData = res.data;
                        this.total = res.total;
                    } else {
                        alert("获取数据失败");
                    }
                });
			this.loadPostAll();
        },
		loadPostAll() {
		    this.$axios
		        .post(this.$httpUrl + "/userorderinfo/list", {
		           userOrderId:this.userOrderId
		        })
		        .then((res) => res.data)
		        .then((res) => {
		            console.log(res);
		            if (res.code == 200) {
		                this.printTable = res.data;
		            } else {
		                alert("获取数据失败");
		            }
		        });
		},
		del(id) {
		    console.log(id);
		
		    this.$axios
		        .get(this.$httpUrl + "/userorderinfo/del?id=" + id)
		        .then((res) => res.data)
		        .then((res) => {
		            console.log(res);
		            if (res.code == 200) {
		                this.$message({
		                    message: "操作成功！",
		                    type: "success",
		                });
		                this.loadPost();
		            } else {
		                this.$message({
		                    message: "操作失败！",
		                    type: "error",
		                });
		            }
		        });
		},
    },
	
    beforeMount() {
        this.loadPost();
    },
};
</script>

<style scoped>
</style>